import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import ActionGet from '../../store/action/WAProfile/Fetch'
import ActionDownload from '../../store/action/WAProfile/Download'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import ActionRejectUpload from '../../store/action/WAProfile/RejectUpload'
import ActionApproveUpload from '../../store/action/WAProfile/ApproveUpload'
import ActionGetDetailUpload from '../../store/action/WAProfile/FetchDetailUpload'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import "./Overview.css"
import { IsEdit, IsCreate, IsView, InputTypeDropdown } from '../../store/constants'
import { PrevilageId, ClientId, DivisionId, SenderId } from '../../helper/HelperAuth'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import DatePickerInput from "../../infra/components/formInput/DatePickerInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ActionRequestDownloadErrorDetail from '../../store/action/WAProfile/RequestDownloadErrorDetail'
import ActionDownloadErrorDetail from '../../store/action/WAProfile/DownloadErrorDetail'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import ActionCancelApproveUpload from '../../store/action/WAProfile/CancelApproveUpload'

class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disrest: false,
            modal: false,
            isadmin:false,
            client_id: '',
            selectedRow: fromJS({}),
            sender_id: [],
            title: "Personal Media",
            panelHeader: fromJS([
                {
                    "id": 6,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Single"
                },
                {
                    "id": 1,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Media Single"
                },
                {
                    "id": 2,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Personal"
                },
                {
                    "id": 3,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Personal Media"
                },
                {
                    "id": 4,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Scheduled Media"
                },
                {
                    "id": 5,
                    "icon": "",
                    "classname": "btn btn-success ",
                    "title": "Upload Scheduled"
                }
            ]),
            searchForm: fromJS({
                "client-id": '',
                "division-id": '',
                "sender-id": '',
                "upload-by": "",
                "filename": "",
                "service-id": '',
                "status-id": '',
                "start-date": "",
                "end-date": ""
            }),
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                // "search": ""
            }),
            sortForm: fromJS({
                'order-by': 3,
                'order': 'DESC'
            }),
            search: fromJS([

            ]),
            columnsView: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className: "col-sm-2", field: "upload-type", caption: "Upload Type", sortId: 2 },
                { className: "col-sm-2", field: "upload-date", caption: "Upload Date", sortId: 3 },
                { className: "col-sm-2", field: "schedule-date", caption: "Schedule", sortId: 5 },
                { className: "col-sm-1", field: "status", caption: "Status" },
                { className: "col-sm-3", field: "file-name", caption: "Filename" },
                {
                    className: "col-sm-2", cfield: "action", caption: "Actions", allowEdit: false, allowView: false, allowDelete: false,
                    custom: fromJS([
                        { "id": "Detail", "icon": "visibility", "className": "text-success" },
                        { "id": "Download", "icon": "cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success" }
                    ])
                }
            ],
            columns: [
                { className: "col-sm-1", cfield: "counter", caption: "No" },
                { className: "col-sm-2", field: "upload-type", caption: "Upload Type", sortId: 2 },
                { className: "col-sm-2", field: "upload-date", caption: "Upload Date", sortId: 3 },
                { className: "col-sm-2", field: "schedule-date", caption: "Schedule", sortId: 5 },
                { className: "col-sm-1", field: "status", caption: "Status" },
                { className: "col-sm-3", field: "file-name", caption: "Filename" },
                {
                    className: "col-sm-2", cfield: "action", caption: "Actions", allowEdit: false, allowView: false, allowDelete: false,
                    custom: fromJS([
                        { "id": "Detail", "icon": "visibility", "className": "text-success" },
                        { "id": "Download", "icon": "cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success" },
                        { "id": "Approve", "icon": "done", "label": "Approve", "className": "text-warning" },
                        { "id": "Reject", "icon": "cancel", "label": "Reject", "className": "text-danger" },
                        { "id": "CancelApprove", "icon": "cancel", "label": "Cancel", "className": "text-danger" }
                    ])
                }
            ],
            action_id: this.handleActionId(),
            errors: fromJS({}),
            service_id: fromJS([
                { value: 1, label: 'SINGLE' },
                { value: 2, label: 'PERSONAL' },
                { value: 3, label: 'SCHEDULED' },
                { value: 4, label: 'SINGLE MEDIA' },
                { value: 5, label: 'PERSONAL MEDIA' },
                { value: 6, label: 'SCHEDULED MEDIA' }
            ]),
            status_id: fromJS([
                { value: 1, label: 'New uploaded' },
                { value: 2, label: 'Validating' },
                { value: 3, label: 'Waiting for approval' },
                { value: 4, label: 'Approved' },
                { value: 5, label: 'Rejected' },
                { value: 6, label: 'Processing' },
                { value: 7, label: 'Queueing' },
                { value: 8, label: 'Completed' }
            ])
        };

        this.showContent = this.showContent.bind(this);
        //this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this)
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
        this.handleHeaderClicked = this.handleHeaderClicked.bind(this);
        this.handleApproveReject = this.handleApproveReject.bind(this);
    }

    async componentDidMount() {
        var formVal = this.state.searchForm
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})
        await this.props.actionGetAccessModule(PrevilageId);
        this.props.actionGetAllClient()
        let restrict = this.handleActionId();
        if (restrict == 5 || restrict == 6) {
        await this.props.actionGetAllDivision(ClientId, 'List Upload')
            this.props.actionGetAllSender(ClientId)
            formVal = formVal.set("client-id", ClientId)
            formVal = formVal.set("division-id", DivisionId)
            formVal = formVal.set("sender-id", SenderId)
            this.setState({
                searchForm: formVal,
                disrest: true
            })
        }
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh) {
        if (refresh) {
            this.handleFindSearch(1)
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleOnBindCustomAction(actionId, row, isAdmin) {
        var datemax = new Date(row.get('schedule-date'));
        var currentdate = new Date();
        var maxCancel = false;
        datemax.setHours(datemax.getHours() - 2);

        if(currentdate.getTime() > datemax.getTime()){
            maxCancel = true;
        }

        if ((actionId === 'Reject' || actionId === 'Approve')) {
            if (row.get('status') !== 'Waiting for approval') {
                return false;
            } 
        }else if(actionId==='CancelApprove'){
            if(row.get('status') == 'Approved' && !maxCancel){
                if(isAdmin){
                    return true;
                }
            }else{
                return false;
            }
        }
        return true;
    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'List Upload') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }

        return action;
    }

    async handleCustomAction(id, row) {
        switch (id) {
            case "Detail":
                //debugger;
                this.props.actionGetDetailUpload(row.get('jobid'))
                this.setState({ modal: true, selectedRow: row });
                break;
            case "Download":
               this.props.actionDownload(row.get('jobid'),row.get('status'), row.get('upload-type'), row.get('file-name'));
                break;
            case "Approve":
                var result1 = await this.props.actionApproveUpload(row.get('jobid'))
                //debugger;
                if (result1.ok) {
                    toast.success("Approve Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                } else {
                    toast.error("Approve Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "Reject":
                var result2 = await this.props.actionRejectUpload(row.get('jobid'))
                //debugger;
                if (result2.ok) {
                    toast.success("Reject Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                } else {
                    toast.error("Reject Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "CancelApprove":
                var result3 = await this.props.actionCancelApproveUpload(row.get('jobid'));
                if (result3.ok) {
                    toast.success("Cancel Approve Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                } else {
                    toast.error("Cancel Approve Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            default:
        }
    }

    async handleRequestDownloadErrorDetail(id, row) {
        switch (id) {
            case "RequestErrorDetail":
                var resultRequest = await this.props.actionRequestDownloadErrorDetail(row.get('jobid'))
                //debugger;
                if (resultRequest.ok) {
                    toast.success("Request Success", toast.POSITION.TOP_RIGHT);
                    //this.handleFindSearch(1);
                    this.setState({ modal: false, selectedRow: fromJS({}) });
                } else {
                    toast.error("Request Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "DownloadErrorDetail":
                var resultDown = await this.props.actionDownloadErrorDetail(row.get('jobid'), row.get('upload-type'))
                //debugger;
                if (resultDown.ok) {
                    toast.success("Download Success", toast.POSITION.TOP_RIGHT);
                    //this.handleFindSearch(1);
                    this.setState({ modal: false, selectedRow: fromJS({}) });
                } else {
                    toast.error("Download Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            default:
        }
    }

    async handleApproveReject(id, row) {
        switch (id) {
            case "Approve":
                var result1 = await this.props.actionApproveUpload(row.get('jobid'))
                //debugger;
                if (result1.ok) {
                    toast.success("Approve Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                    this.setState({ modal: false, selectedRow: fromJS({}) });
                } else {
                    toast.error("Approve Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            case "Reject":
                var result2 = await this.props.actionRejectUpload(row.get('jobid'))
                //debugger;
                if (result2.ok) {
                    toast.success("Reject Success", toast.POSITION.TOP_RIGHT);
                    this.handleFindSearch(1)
                    this.setState({ modal: false, selectedRow: fromJS({}) });
                } else {
                    toast.error("Reject Failed", toast.POSITION.TOP_RIGHT);
                }
                break;
            default:
        }
    }

    handleNew(actionId) {
        if (actionId === 1) {
            window.location = "SingleUpload";
        } else if (actionId === 2) {
            window.location = "PersonalUpload";
        } else if (actionId === 3) {
            window.location = "PersonalUploadMedia";
        } else if (actionId === 4) {
            window.location = "PersonalScheduleUpload";
        } else if (actionId === 5) {
            window.location = "Scheduled";
        } else if (actionId === 6) {
            window.location = "UploadSingle";
        }
    }
    handleViewClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field, value);
        if (field === 'client-id') {
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value, 'List Upload');
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ searchForm: formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ searchForm: formVal })

    }

    handleEditClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let sender_id = searchForm.get('sender-id');
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let service_type = searchForm.get('service-id');
        let upload_status = searchForm.get('status-id');
        let res = null;
        let sender = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin

        if (client_id === "") client_id = 0;
        if (division_id === "") division_id = 0;
        if (service_type === "") service_type = 0;
        if (upload_status === "") upload_status = 0;

        if ((sender_id === "" || sender_id == undefined || sender_id === " ") && client_id != 0) {
            if (PrevilageId != 1 && isAdmin == false) {
                client_id = ClientId;
                division_id = DivisionId;
            }
            this.props.actionGetAllSender(client_id, division_id)

            setTimeout(() => {
                res = this.props.senderall;
                if (res.size > 0) {
                    sender = [];
                }

                {
                    res.map((data, i) =>
                        sender.push(data.get('sender-id'))
                    )
                }
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "upload-by": searchForm.get('upload-by'),
                    "filename": searchForm.get('filename'),
                    "servicetype": service_type,
                    "upload-status": upload_status,
                    "date-start": searchForm.get('start-date'),
                    "date-end": searchForm.get('end-date')
                }
                this.props.actionGet(page, this.state.sortForm, bodyFInd,isAdmin);

            }, 3000);

        } else {
            if (PrevilageId != 1 && isAdmin == false) {
                client_id = ClientId;
                division_id = DivisionId;
                if (this.state.actionId != 5 || this.state.actionId != 6) {

                    this.props.actionGetAllSender(client_id, division_id)
                } setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) {
                        sender = [];
                    }
                    {
                        res.map((data, i) =>
                            sender.push(data.get('sender-id'))
                        )
                    }

                    if (sender_id != "") sender = [sender_id]

                    bodyFInd = {
                        "client-id": client_id,
                        "division-id": division_id,
                        "sender-id": sender,
                        "upload-by": searchForm.get('upload-by'),
                        "filename": searchForm.get('filename'),
                        "servicetype": service_type,
                        "upload-status": upload_status,
                        "date-start": searchForm.get('start-date'),
                        "date-end": searchForm.get('end-date')
                    }
                    this.props.actionGet(page, this.state.sortForm, bodyFInd,isAdmin);
                }, 3000);
            } else {
                sender = [];
                sender.push(sender_id)
                bodyFInd = {
                    "client-id": client_id,
                    "division-id": division_id,
                    "sender-id": sender,
                    "upload-by": searchForm.get('upload-by'),
                    "filename": searchForm.get('filename'),
                    "servicetype": service_type,
                    "upload-status": upload_status,
                    "date-start": searchForm.get('start-date'),
                    "date-end": searchForm.get('end-date')
                }
                this.props.actionGet(page, this.state.sortForm, bodyFInd);
            }
        }
    }

    handleFind() {
        this.handleFindSearch(1)
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }
    refreshGrid(page, search) {
        this.handleFindSearch(page)
    }
    handleCloseModal() {
        this.setState({ modal: false });
    }
    async handleRemoveClicked(value) {
    }
    handleHeaderClicked(field, sortId) {
        var f = this.state.sortForm;
        if (f.get('order-by') !== sortId) {
            f = fromJS({
                'order-by': sortId,
                'order': 'ASC'
            })
        } else {
            f = fromJS({
                'order-by': sortId,
                'order': f.get('order') === 'ASC' ? 'DESC' : 'ASC'
            })
        }

        this.setState({ sortForm: f })
        this.refreshGrid(1, f);
    }

    showContent() {
        const items = this.props.data ? fromJS(this.props.data) : fromJS({});
        let columnsData = this.state.columns;
        let action_id = this.handleActionId()
        if (action_id == 1 || action_id == 3 || action_id == 5) {
            columnsData = this.state.columnsView;
        }
        return (
            <CustomGrid
                // panelHeader={ this.state.panelHeader }
                title="Personal Media"
                columns={columnsData}
                items={items}
                isAdmin={this.state.isAdmin}
                //search={ false }
                // handleNew={ this.handleNew }
                //handleSearch={ this.handleSearch }
                handleOnBindCustomAction={this.handleOnBindCustomAction}
                handleCustomAction={this.handleCustomAction}
                handleViewClicked={this.handleViewClicked}
                handleEditClicked={this.handleEditClicked}
                handleRemoveClicked={this.handleRemoveClicked}
                handlePageChanged={this.handlePageChanged}
                sortForm={this.state.sortForm}
                handleHeaderClicked={this.handleHeaderClicked}
            >
            </CustomGrid>
        )
    }

    render() {
        const { form, modal, selectedRow, errors, searchForm } = this.state;
        const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add" : "Edit") : "Upload List";
        var btndisplay = selectedRow.get('status') === 'Waiting for approval' ? '' : 'none';

        // Check button display of Cancel button
        var btndisplaycancel = selectedRow.get('status') === 'Approved' ? '' : 'none';
        var datemax = new Date(selectedRow.get('schedule-date'));
        var currentdate = new Date();
        datemax.setHours(datemax.getHours() - 2);
        if(selectedRow.get('schedule-date')){
            if(currentdate.getTime() > datemax.getTime()){
                btndisplaycancel = 'none';
            }
        }

        if (this.state.action_id == 1 || this.state.action_id == 3 || this.state.action_id == 5) {
            btndisplay = 'none'
        }
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className="card">
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Division"
                                    disabled={this.state.disrest}
                                    // disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                    disabled={this.state.disrest}
                                    // disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='status-id'
                                    value={searchForm.get('status-id')}
                                    options={fromJS({
                                        'source': this.state.status_id,
                                        'value': 'value',
                                        'label': 'label'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Status"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('status-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='service-id'
                                    value={searchForm.get('service-id')}
                                    options={fromJS({
                                        'source': this.state.service_id,
                                        'value': 'value',
                                        'label': 'label'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Service"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('service-id')}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <TextInputField className="form-control"
                                    field='upload-by'
                                    value={searchForm.get('upload-by')}
                                    onChange={(field, value) => this.handleChange(field, value, '')}
                                    placeholder="Upload By"
                                    disabled={false}
                                    hasError={errors.has('upload-by')}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <TextInputField className="form-control"
                                    field='filename'
                                    value={searchForm.get('filename')}
                                    onChange={(field, value) => this.handleChange(field, value, '')}
                                    placeholder="File Name"
                                    disabled={false}
                                    hasError={errors.has('filename')}
                                />
                            </div>
                            <span className="col-sm-1">Start</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    dateFormat="yyyy-MM-dd"
                                    convertvalue
                                    field="start-date"
                                    value={searchForm.get('start-date')}
                                    onChange={(field, date) => this.handleChange(field, date)}
                                />
                            </div>
                            <span className="col-sm-1">End</span>
                            <div className="col-sm-2">
                                <DatePickerInput
                                    convertvalue
                                    dateFormat="yyyy-MM-dd"
                                    field="end-date"
                                    value={searchForm.get('end-date')}
                                    onChange={(field, date) => this.handleChange(field, date)}
                                    minDate={new Date(searchForm.get('start-date'))}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-12">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }

                <Modal isOpen={modal} toggle={() => { }} fade={false} >
                    <ModalHeader>
                        Detail
                        <button className={`btn-close bg-red pull-right`} onClick={() => this.handleCloseModal()} >
                            <i class="material-icons">clear</i>
                        </button>
                    </ModalHeader>
                    <ModalBody>
                        <table class="table">
                            <tbody>
                                {
                                    this.props.uploaddetail.map((item) => {
                                        if (item.get('f') == "Download Validation Result") {
                                            if (item.get('v') == "Request File") {
                                                return (
                                                    <tr>
                                                        <td>{item.get('f')}</td>
                                                        <td> : </td>
                                                        <td>
                                                            <button className={`btn btn-success btn-round`}
                                                                onClick={() => this.handleRequestDownloadErrorDetail('RequestErrorDetail', selectedRow)}>
                                                                {item.get('v')}
                                                            </button>

                                                        </td>
                                                    </tr>
                                                )
                                            } else if (item.get('v') == "File Ready to Download") {
                                                return (
                                                    <tr>
                                                        <td>{item.get('f')}</td>
                                                        <td> : </td>
                                                        <td>
                                                            <button className={`btn btn-success btn-round`}
                                                                onClick={() => this.handleRequestDownloadErrorDetail('DownloadErrorDetail', selectedRow)}>
                                                                <i className="material-icons">cloud_download</i>   {item.get('v')}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            return (
                                                <tr>
                                                    <td>{item.get('f')}</td>
                                                    <td> : </td>
                                                    <td>{` ${item.get('v')}`}</td>
                                                </tr>
                                            )
                                        }
                                        return (
                                            <tr>
                                                <td>{item.get('f')}</td>
                                                <td> :</td>
                                                <td>{` ${item.get('v')}`}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter>
                        <div className="col-md-2" style={{ textAlign: "left" }}>
                            <button style={{ display: btndisplay }} className={`btn  btn-success`} onClick={() => this.handleApproveReject('Approve', selectedRow)} >
                                <i class="material-icons">check</i>   Approve
                            </button>
                            <button style={{ display: btndisplaycancel }} className={`btn  btn-danger`} onClick={() => this.handleCustomAction('CancelApprove', selectedRow)} >
                                <i class="material-icons">close</i> Cancel
                            </button>
                        </div>
                        <div className="col-md-2" style={{ textAlign: "left" }}>
                            <button style={{ display: btndisplay }} className={`btn  btn-danger`} onClick={() => this.handleApproveReject('Reject', selectedRow)} >
                                <i class="material-icons">close</i> Reject
                            </button>
                        </div>
                        <div className="col-md-8">
                            <button className={`btn btn-danger btn-round`} onClick={() => this.handleCloseModal()} >
                                Close
                            </button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            accessmodules: state.user.accessmodules,
            data: state.user.waprofiles,
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            uploaddetail: state.user.uploaddetail
        }
    },
    dispatch => bindActionCreators({
        actionGetAccessModule: ActionGetAccessModule,
        actionGet: ActionGet,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionRejectUpload: ActionRejectUpload,
        actionCancelApproveUpload: ActionCancelApproveUpload,
        actionApproveUpload: ActionApproveUpload,
        actionGetDetailUpload: ActionGetDetailUpload,
        actionDownload: ActionDownload,
        actionRequestDownloadErrorDetail: ActionRequestDownloadErrorDetail,
        actionDownloadErrorDetail: ActionDownloadErrorDetail,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(Page);